import { BaseFeature } from '../../core/base-feature.js';

/**
 * DebugWindowFeature - Frontend control to summon the desktop's debug/feature-host
 * window. That window has no local entry point on the desktop (its default face is
 * the consent console), so the website is the only way to open it.
 */
export class DebugWindowFeature extends BaseFeature {
    static getMetadata() {
        return {
            id: 'debug-window',
            name: 'Desktop Debug Window',
            version: 'v1.0',
            capabilities: ['show', 'hide'],
            dependencies: []
        };
    }

    async handleMessage() { /* fire-and-forget commands; no inbound messages */ }

    /** Open the debug/feature-host window on the paired desktop. */
    showDebugWindow() { this.sendMessage('show', {}); }

    async cleanup() {}
}
